import BaseService from "./base.service";
import http from "../http-common";
import { checkEnterpriseId, getResponseData } from "../helpers/_functions";

class WorkedHoursTypesAutoAdjustSettingService extends BaseService {
  constructor() {
    super("worked-hours-types-auto-adjust-setting");
  }

  get() {
    const enterpriseId = checkEnterpriseId();
    return http
      .get(`${this.path}/get`, { params: { enterpriseId } })
      .then((response) => getResponseData(response));
  }

  shouldShowOvertimeRequestEndDate({ employeeId, startDate }) {
    const enterpriseId = checkEnterpriseId();
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return http
      .get(`${this.path}/should-show-overtime-request-endDate`, {
        params: { employeeId, enterpriseId, timezone, startDate }
      })
      .then((response) => getResponseData(response));
  }

  shouldShowOvertimeRequestStartDate(employeeId) {
    const enterpriseId = checkEnterpriseId();
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return http
      .get(`${this.path}/should-show-overtime-request-startDate`, {
        params: { employeeId, enterpriseId, timezone }
      })
      .then((response) => getResponseData(response));
  }

  upsert(data) {
    const enterpriseId = checkEnterpriseId();
    return http
      .post(`${this.path}/upsert`, data, { params: { enterpriseId } })
      .then((response) => getResponseData(response));
  }
}

export default new WorkedHoursTypesAutoAdjustSettingService();
